import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IListProjectTypeRequest extends IBaseRequest {
    fixedType?: number;
    canBeRoot?: boolean;
    systemType?: number;
    categoryId?: number;
    fpaTypeCategory?:string;
}

export class ListProjectTypeRequest extends BaseRequest implements IListProjectTypeRequest{
    public fixedType?: number;
    public canBeRoot?: boolean;
    public systemType?: number;
    public categoryId?: number;
    public fpaTypeCategory?:string;

    constructor(_server:string, _sessionId:string, 
        _fpaTypeCategory?:string,
        _fixedType?: number, 
        _canBeRoot?: boolean, 
        _systemType?: number, 
        _categoryId?: number, 
        ) {

        super(_server, _sessionId);
        this.fixedType = _fixedType;
        this.canBeRoot = _canBeRoot;
        this.systemType = _systemType;
        this.categoryId = _categoryId;
        this.fpaTypeCategory = _fpaTypeCategory;
    }

    toXml(): string {
        var parameters:string = super.toXml();
        parameters += this.makeNode(this.fixedType, 'fixedType');
        parameters += this.makeNode(this.canBeRoot, 'canBeRoot');
        parameters += this.makeNode(this.systemType, 'systemType');
        parameters += this.makeNode(this.categoryId, 'categoryId');
        parameters += this.makeNode(this.fpaTypeCategory, 'fpaTypeCategory');

        return super.wrapperXml("ListProjectType", parameters);
    }
}